<!--
  THE AGE CHIP — our own bordered type, nobody's seal.

  The MPAA card, the TV Parental Guidelines block and the BBFC roundel are all
  somebody else's trade dress, so this draws none of them: a hairline border and
  the label set small, the same idea as the classification slug in a film
  listing. It inherits the meta line's colour so it sits at the line's own
  volume — a certification is information, not a badge of honour, and it must
  never compete with the title.

  It says the label out loud for a screen reader ("Rated PG-13") the same way
  AwardMark does — `role="img"` with an `aria-label` — because the visible text
  ("15+") is not a sentence.
-->
<script lang="ts">
  import type { Cert } from './certs.svelte';

  interface Props {
    cert: Cert;
  }

  let { cert }: Props = $props();
</script>

<span class="cert" role="img" aria-label={cert.spoken} title={cert.spoken}>{cert.label}</span>

<style>
  .cert {
    display: inline-flex;
    flex: none;
    align-items: center;
    padding: 1px 5px;
    border-radius: 4px;
    /* The border carries the chip; currentColor keeps it exactly as loud as the
       line it sits in, on every surface and in every theme. */
    border: 1px solid color-mix(in oklab, currentColor 62%, transparent);
    font-size: var(--text-2xs);
    font-weight: var(--weight-semi);
    letter-spacing: 0.045em;
    line-height: var(--leading-tight);
    white-space: nowrap;
  }
</style>
